import { render, staticRenderFns } from "./AppleLogin.vue?vue&type=template&id=95b2227a&scoped=true&"
import script from "./AppleLogin.vue?vue&type=script&lang=js&"
export * from "./AppleLogin.vue?vue&type=script&lang=js&"
import style0 from "./AppleLogin.vue?vue&type=style&index=0&id=95b2227a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b2227a",
  null
  
)

export default component.exports